import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TrSelectComponent } from './tr-select.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
    ],
    exports: [ TrSelectComponent ],
    declarations: [ TrSelectComponent ],
})
export class TrSelectModule {}
